import DashboardWrapper from '../../layout/DashboardWrapper';
import { Button } from '../../components/ui/button';
const ComingSoon = () => {
    return (
        <DashboardWrapper>
            <div className="flex flex-col items-center justify-center min-h-[50vh] bg-neutral-50">
                <img
                    src="/undraw_under-construction_c2y1.svg"
                    alt="Page coming soon"
                    style={{ width: '50%', maxWidth: '400px' }}
                />
                <h1 className="text-[16px] md:text-[20px] font-bold text-neutral-950 mt-8 text-center">
                    Page coming soon under development
                </h1>
                <Button variant="destructive" className="w-1/4 mt-6 capitalize" onClick={() => window.history.back()}>
                    Go Back
                </Button>
            </div>
        </DashboardWrapper>
    );
};

export default ComingSoon;
